
import clsx from 'clsx'
import {useContext, useState} from 'react'
import {KTIcon} from '../../../../helpers'
import {CreateAppModal, Dropdown1} from '../../../../partials'
import {LayoutContext, useLayout} from '../../../core'
import { ButtonState, ToolbarContext } from '../Toolbar'
import { Navbar } from '../../header/Navbar'
import { BranchPicker } from '../../../../../app/modules/settings/BranchSettings'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ButtonWithLoader from '../../../../../app/modules/widgets/components/ButtonWithLoader'

const ToolbarClassic = () => {
  const { config } = useLayout();
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false);
  const daterangepickerButtonClass = config.app?.toolbar?.fixed?.desktop
    ? 'btn-light'
    : 'bg-body btn-color-gray-700 btn-active-color-primary';
  const layoutContext = useContext(LayoutContext);
  const toolbarConfig = layoutContext?.config.app?.toolbar;
  const { toolbarState } = useContext(ToolbarContext);

  // Update the renderButton function to handle components
const renderButton = (button: ButtonState) => {
  if (!button.enabled) return null;
  
  // If component is provided, render it directly
  if (button.component) {
    return button.component;
  }
  
  // Otherwise render the standard button
  if (!button.text || !button.action) return null;

  const buttonClass = button.primary ? `btn btn-sm btn-flex btn-primary fw-bold ${button.className}` : `btn btn-sm btn-flex btn-light fw-bold  ${button.className}`;

  return (
    <ButtonWithLoader
      shortcutKeys={button.shortcutKeys}
      shortcutTip={button.shortcutTip}
      tooltipPlacement="bottom"
      className={buttonClass}
      onClick={button.action}
    >
      {button.icon && <i className={`far ${button.icon} me-2`}></i>}
      {button.text.toTranslatedDisplay()}
    </ButtonWithLoader>
  );
};

  return (
    <div className="d-flex align-items-center gap-2 gap-lg-3">
      {/* {config.app?.toolbar?.filterButton && (
        <div className="m-0">
          {renderButton(toolbarState.secondaryButton)}
          <Dropdown1 />
        </div>
      )}

      {config.app?.toolbar?.daterangepickerButton && (
        <div
          data-kt-daterangepicker="true"
          data-kt-daterangepicker-opens="left"
          className={clsx(
            'btn btn-sm fw-bold d-flex align-items-center px-4',
            daterangepickerButtonClass
          )}
        >
          <div className="text-gray-600 fw-bold">Loading date range...</div>
          <KTIcon iconName="calendar-8" className="fs-1 ms-2 me-0" />
        </div>
      )} */}
      {renderButton(toolbarState.tertiaryButton)}

      {renderButton(toolbarState.secondaryButton)}

      {renderButton(toolbarState.primaryButton)}

      {/* {toolbarState.showBranchPicker &&  <BranchPicker /> } */}


      <Navbar />
      <CreateAppModal show={showCreateAppModal} handleClose={() => setShowCreateAppModal(false)} />
    </div>
  );
};


export {ToolbarClassic}
